module.exports = __webpack_public_path__ + "media/king-of-pops.ec1f6358.mp4";